import React, { useState } from "react";
import { Link } from "react-router-dom"
import { updateSurveyorAssignmentOperationValue } from "requesters/surveyorAssignmentRequester"
import { useSelector } from "react-redux";
import { getBaseUrl } from "../../../reducers";

const BookingRow = ({ booking, reloadData }) => {
  const baseUrl = useSelector(getBaseUrl)
  const [editingAssignmentId, setEditingAssignmentId] = useState(null)
  const [tempOperationValue, setTempOperationValue] = useState("")

  const {
    bookingTime, checkIn, checkOut, duration, dateAndTimeSentToDrafting, address, type,
    percentage, price, jobServiceId, jobId, operationValue, assignmentId, hasCustomOperationValue
  } = booking

  const onEditOperationValue = (assignmentId, currentValue) => {
    setEditingAssignmentId(assignmentId)
    setTempOperationValue(currentValue.replace(/[+$-]/g, ""))
  }

  const onSaveOperationValue = async assignmentId => {
    try {
      const payload = { operation_value: parseFloat(tempOperationValue) || 0 }
      const response = await updateSurveyorAssignmentOperationValue(baseUrl, assignmentId, payload)

      if (response.status === 200) {
        setEditingAssignmentId(null)
        setTempOperationValue("")
        if (reloadData) {
          reloadData()
        }
      }
    } catch (error) {
      console.error("Error updating operation value:", error)
    }
  }

  const onCancelEditOperationValue = () => {
    setEditingAssignmentId(null)
    setTempOperationValue("")
  }

  const handleKeyPress = (e, assignmentId) => {
    if (e.key === "Enter") {
      onSaveOperationValue(assignmentId)
    } else if (e.key === "Escape") {
      onCancelEditOperationValue()
    }
  }

  return (
    <tr>
      <td>{bookingTime}</td>
      <td>{checkIn}</td>
      <td>{checkOut}</td>
      <td>{duration}</td>
      <td>{dateAndTimeSentToDrafting}</td>
      <td>
        <Link to={`/jobs/${jobId}/job_services/${jobServiceId}`} target="_blank" className="link-no-decoration">{address}</Link>
      </td>
      <td>{type}</td>
      <td>{percentage}</td>
      <td className="text-right">{price}</td>
      <td className="text-right">
        {editingAssignmentId === assignmentId ? (
          <div className="d-flex align-items-center">
            <span className="mr-1">$</span>
            <input
              type="number"
              step="0.01"
              value={tempOperationValue}
              onChange={e => setTempOperationValue(e.target.value)}
              onKeyDown={e => handleKeyPress(e, assignmentId)}
              className="form-control form-control-sm"
              style={{ width: "70px" }} />
            <button type="button" className="btn btn-sm btn-success ml-1" onClick={() => onSaveOperationValue(assignmentId)} title="Save">
              ✓
            </button>
            <button type="button" className="btn btn-sm btn-secondary ml-1" onClick={onCancelEditOperationValue} title="Cancel">
              ✕
            </button>
          </div>
        ) : (
          <span 
            className={`cursor-pointer ${hasCustomOperationValue ? "text-primary" : ""}`} 
            onClick={() => onEditOperationValue(assignmentId, operationValue)} 
            title={hasCustomOperationValue ? "operation_value - Click to edit" : "Calculated value - Click to set operation_value"}
          >
            {operationValue}
          </span>
        )}
      </td>
    </tr>
  )
}

export default BookingRow